import GridRoute from 'eflex/util/grid-route';
import { service } from '@ember/service';
import { isBlank } from '@ember/utils';
import { task } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';
import { removeNullProperties } from 'eflex/helpers';

export default class PartsGenealogyRoute extends GridRoute {
  @service eflexAjax;

  paginate = false;

  queryParams = {
    searchMode: {
      refreshModel: true,
    },
  };

  getData = task(waitFor(async (params = {}) => {
    if (isBlank(params.searchTerm)) {
      return null;
    }

    return await this.eflexAjax.get.perform('marriages', removeNullProperties(params));
  }));
}
